import React from 'react';
import { Leaf, Heart, Users, Award, Package, TrendingUp } from 'lucide-react';
import { benefitsData } from '../data/mockData';

const iconMap = {
  Leaf,
  Heart,
  Users,
  Award,
  Package,
  TrendingUp
};

export const Benefits = () => {
  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-gray-50 to-pink-50">
      <div className="container mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Por que Escolher a Plantinha de Geladeira?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Um presente além do óbvio, que conecta com a natureza, desperta sentimentos e cria laços genuínos com todos da casa.
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-[#eb068c] to-[#c7056f] mx-auto rounded-full mt-6"></div>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {benefitsData.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div 
                key={index}
                className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-pink-100"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-[#eb068c] to-[#c7056f] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <IconComponent className="h-8 w-8 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom highlight */}
        <div className="mt-16 max-w-4xl mx-auto bg-gradient-to-r from-[#eb068c] to-[#c7056f] rounded-2xl p-8 md:p-10 text-white text-center shadow-xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Transforme ações em presença
          </h3>
          <p className="text-pink-50 text-lg">
            Conexão real, todos os dias.
          </p>
        </div>
      </div>
    </section>
  );
};
